import React, { useEffect, useState } from 'react';
import { Dropdown, Button, Space, Typography } from 'antd';
import { GlobalOutlined, DownOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';


const { Text } = Typography;

const LangSelector = () => {
  const savedLanguage = localStorage.getItem('lang_selection');
  const [selectedLang, setSelectedLang] = useState();
  const { i18n } = useTranslation();

  const items = [
    {
      key: 'en',
      label: 'English',
      icon: <span>🇺🇸</span>,
      short: 'EN',
    },
    {
      key: 'ar',
      label: 'العربية', // Native script
      icon: <span>🇸🇦</span>,
      short: 'AR',
    },
  ];

  useEffect(() => {
    if (savedLanguage) {
      const l = items.find(i => i.key === savedLanguage)
      setSelectedLang(l.short)
    }
  }, [savedLanguage])

  const handleMenuClick = ({ key }) => {
    const lang = items.find((item) => item.key === key);
    setSelectedLang(lang.short);
    console.log(`Switching to: ${key}`);
    i18n.changeLanguage(key);
    localStorage.setItem('lang_selection', key);
  };

  return (
    <Dropdown
      menu={{
        items,
        onClick: handleMenuClick,
        selectable: true,
        defaultSelectedKeys: [savedLanguage],
      }}
      trigger={['click']}
      placement="bottomRight"
    >
      <Button type="text" style={{ padding: '0 8px' }}>
        <Space spacing={4}>
          <GlobalOutlined style={{ fontSize: '16px' }} />
          <Text strong style={{ fontSize: '14px' }}>
            {selectedLang}
          </Text>
          <DownOutlined style={{ fontSize: '10px', color: '#999' }} />
        </Space>
      </Button>
    </Dropdown>
  );
};

export default LangSelector;